// Function loadShopItemsWidget loads the ShopItemsWidget class by dynamically importing the js on demand if needed

export function loadShopItemsWidget($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-shop-items-widget-chunk" */ '../widgets/shopItemsWidget').then(wg => {

		const { ShopItemsWidget } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ShopItemsWidget"]');

		if(!$wg) {
			// console.info('ShopItemsWidget: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ShopItemsWidget"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ShopItemsWidget($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ShopItemsWidget($wg);
		}


	}).catch(error => error+'An error occurred while loading the ShopItemsWidget widget');

}
